<template>
    <div class="btn"
         @click="onClick"
         :style="{background:btnBgColor,color:btnColor,width:btnWidth+'px',height:btnHeight+'px',fontSize:fontSize+'px'}"
    >
        <span :style="{fontWeight:fontWeight}">{{title}}</span>
        <slot name="icon"></slot>
        <i v-if="isIcon" class="el-icon-arrow-right"></i>
        <div class="box" :style="{background:btnHoverColor}"></div>
    </div>
</template>

<script>
    export default {
        props: {
            //按钮名称
            title: {
                type: String,
                default: '动画按钮'
            },
            //按钮宽度
            btnWidth: {
                type: String,
                default: '290'
            },
            //按钮高度
            btnHeight: {
                type: String,
                default: '44'
            },
            //按钮颜色
            btnBgColor: {
                type: String,
                default: '#2587FF'
            },
            //按钮hover颜色
            btnHoverColor: {
                type: String,
                default: '#126EDF'
            },
            //按钮字体颜色
            btnColor: {
                type: String,
                default: '#fff'
            },
            //字体大小
            fontSize: {
                type: String,
                default: '18'
            },
            //是否需要图标
            isIcon: {
                type: Boolean,
                default: true
            },
            //字体粗度
            fontWeight: {
                type: String,
                default: '400'
            }
        },
        methods:{
            onClick() {
                this.$emit('click')
            }
        }
    }
</script>

<style lang='scss' scoped>
    @import "@/assets/css/theme.scss";

    .btn {
        font-size: 18px;
        /*font-family: Source Han Sans CN;*/
        width: 290px;
        height: 44px;
        color: $cf;
        background: $main-col;
        text-align: center;
        cursor: pointer;
        position: relative;
        transform: perspective(1px);
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 2px;

        span {
            line-height: 18px;
        }

        .el-icon-arrow-right {
            transition: 0.5s cubic-bezier(0.52, 1.64, 0.37, 0.66);
        }

        .box {
            background: $main-hover;
            transform: scaleX(0);
            position: absolute;
            transform-origin: 0 50%;
            z-index: -1;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            transition: 0.5s cubic-bezier(0.52, 1.64, 0.37, 0.66);
            opacity: 0;
        }

        &:hover {
            .box {
                transform: scaleX(1);
                opacity: 1;
            }

            .el-icon-arrow-right {
                transform: translateX(25%);
            }
        }
    }
</style>